import React from 'react'
import land from './landing_.png'
import {handle} from '../events'
import {Rect} from 'react-konva'
import * as Behaviours from 'alcumus-behaviours'

import useImage from 'use-image'
import {addGameObject, createGameObject} from '../system'
import {getState} from '../game-surface'

function Land() {
    const [image] = useImage(land)
    return !image ? null : (
        <Rect
            x={0}
            y={300 + this.$.y}
            fillPatternRepeat="no-repeat"
            fillPatternImage={image}
            fillPatternScaleX={1.4}
            fillPatternScaleY={1.4}
            width={2048}
            height={1024}
        />
    )
}

Behaviours.register('land', {
    initialize() {
        this.patternY = this.patternY || 0
        this.document.speed = this.document.speed || 100
        handle('resetGame', () => {
            this.$.y = 0
        })
        handle('startGame', () => {
            this.$.y = 0
        })
    },

    postInitialize() {
        this.document.addChild(
            createGameObject(
                {opacity: 1},
                {
                    sprite: {Sprite: Land.bind(this)},
                }
            )
        )
    },
    methods: {
        update(dt) {
            this.$.y += this.document.speed * dt * getState().rocketSpeed * 3.5
        },
    },
})

handle('initializeGame', () => {
    addGameObject(
        {x: 0, y: 0, scale: 1, z: -100, speed: 350},
        {
            land: {},
        }
    )
})
